
if (!customElements.get('custom-select')) {
    customElements.define(
        "custom-select",
        class CustomSelect extends HTMLElement {
            constructor() {
                super();
            }

            connectedCallback() {
                this.details = this.querySelector('details');
                this.summary = this.querySelector('summary');
                this.options = this.querySelectorAll('li');
                this.connectedElement = this.getAttribute('data-connected-element');
                this.defaultValue = this.getAttribute('data-default-value');
                this.percentageContainer = this.getAttribute('data-percentage-container');

                this.summary.addEventListener('click', this.toggle.bind(this));
                this.options.forEach((option) => {
                    const handleClickEvent = () => { 
                        this.select(option, false);

                        if (this.connectedElement) {
                            const connectedElement = this.parentElement.querySelector(this.connectedElement);
                            connectedElement.value = option.dataset.sellingPlanId;
                            connectedElement.dispatchEvent(new Event('change', { bubbles: true }));
                        }

                        this.toggle();
                    };

                    option.addEventListener('click', handleClickEvent);
                    option.addEventListener('keydown', (e) => {
                        if (e.key === 'Enter') {
                            handleClickEvent();
                        }
                    });
                });

                this.selectDefault();
                this.handleOutsideClick();
            }

            handleOutsideClick() {
                document.addEventListener('click', (e) => {
                    if (!this.contains(e.target)) {
                        this.details.removeAttribute('open');
                    }
                });
            }

            select(option, isSkip = true) {
                if (!option) return;

                this.options.forEach((option) => {
                    option.removeAttribute('data-selected');
                });
                
                this.summary.querySelector(".selected-option-title").textContent = option.textContent;
                this.summary.dataset.percentage = option.dataset.percentage;
                this.summary.dataset.sellingPlanId = option.dataset.sellingPlanId;
                this.summary.dataset.price = option.dataset.price;
                this.summary.dataset.compareAtPrice = option.dataset.compareAtPrice;
                option.setAttribute('data-selected', 'true');

                if (this.closest('label') && !isSkip) {
                    const input = this.closest('label').querySelector('input[type="radio"]');
                    input.checked = true;
                    input.dispatchEvent(new Event('change', { bubbles: true }));
                }

                if (this.percentageContainer) {
                    const percentageContainer = document.querySelector(this.percentageContainer);
                    if (percentageContainer) {
                        percentageContainer.textContent = option.dataset.percentage + '%';
                    }
                }
            }

            selectDefault() {

                let selectedOption = this.querySelector('li:first-child');

                if (this.defaultValue) {
                    selectedOption = this.querySelector(`li[data-selling-plan-id="${this.defaultValue}"]`);
                }

                this.select(selectedOption);
            }

            toggle(e) {
                e && e.preventDefault();
                this.details.open ? this.details.removeAttribute('open') : this.details.setAttribute('open', '');
            }
        })
}